// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M1 9V1H9L1 9Z" fill={props.color} />
			<path d="M23 15L23 23L15 23L23 15Z" fill={props.color} />
			<path d="M15 1L23 1L23 9L15 1Z" fill={props.color} />
			<path d="M9 23L1 23L1 15L9 23Z" fill={props.color} />
		</svg>
	</>
);

export default Icon;
